import React, { useState, useEffect } from "react";
import TweetBox from "./TweetBox";
import Post from "./Post";
import "./Feed.css";
import db from "./firebase";
import FlipMove from "react-flip-move";

function Feed() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    db.collection("posts").onSnapshot(snapshot => (
      setPosts(snapshot.docs.map(doc => doc.data()))
    ));
  }, []);

  return (
    <div className="feed">
      <div className="feed__header">
        <h2>Home</h2>
      </div>

      <TweetBox />

        <Post 
        avatar="https://avatars.githubusercontent.com/u/93612680?v=4"
        displayName="Mallory Shackford"
        username='mb_shack'
        verified
        text="It's working!"
        image="https://media.giphy.com/media/YFkpsHWCsNUUo/giphy.gif"
         />
        <FlipMove>
        {posts.map(post => (
          <Post
            key={post.text}
            displayName={post.displayName}
            username={post.username}
            verified={post.verified}
            text={post.text}
            avatar={post.avatar}
            image={post.image}
          />
        ))}
        </FlipMove>
    </div>
  );
}

export default Feed;


